<template>
  <div class="animated fadeIn" style="overflow-y:hidden">

    <div class="row">
      <div class="col">
        <b-btn @click="searchModalShow = !searchModalShow" :disabled="showLoadingAnimation">Filter</b-btn>
        <span> By </span>
        <span v-if="filterObject.campaignId.length > 0">[Campaign id]: {{filterObject.campaignId}} </span>
        <span v-if="filterObject.requester.length > 0">and [Email]: {{filterObject.requester}} </span>
        <span
          v-if="filterObject.invoiceNumberOne.length > 0">and [invoiceNumberOne]: {{filterObject.invoiceNumberOne}} </span>
        <span
          v-if="filterObject.invoiceNumberTwo.length > 0">and [invoiceNumberTwo]: {{filterObject.invoiceNumberTwo}} </span>
        <span v-if="filterObject.status.length > 0">and [tax invoice]: {{filterObject.status}} </span>
        <b-btn @click="clearFilters()" :disabled="showLoadingAnimation">Clear Filters</b-btn>
      </div>
    </div>

    <!-- Modal Component -->
    <b-modal id="modal1" title="Filter" v-model="searchModalShow">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col><label for="campaignName">Campaign id:</label></b-col>
        <b-col><input type="text" id="campaignName" placeholder="" v-model="filterObject.campaignId"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="email">Email:</label></b-col>
        <b-col><input type="text" id="email" placeholder="" v-model="filterObject.requester"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="invoiceNumberOne">Invoice Number One:</label></b-col>
        <b-col><input type="text" id="invoiceNumberOne" placeholder="" v-model="filterObject.invoiceNumberOne"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="status">Status:</label></b-col>
        <b-col><input type="text" id="status" placeholder="" v-model="filterObject.status"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="invoiceNumberTwo">Invoice Number Two:</label></b-col>
        <b-col><input type="text" id="invoiceNumberTwo" placeholder="" v-model="filterObject.invoiceNumberTwo"></b-col>
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="primary" @click="filterTable()">
          Filter
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="searchModalShow = !searchModalShow">
          Close
        </b-btn>
      </div>
    </b-modal>

    <div class="row">
      <div class="col">
        <span> Rows Per Page:</span>
        <!-- <input v-model="rowsPerPageC" type="number"/> -->
        <b-dropdown id="ddown3" :text="rowsPerPageCText" class="m-md-1" :disabled="showLoadingAnimation">
          <b-dropdown-item href="#" @click="rowsPerPageSelected(10)">10</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(20)">20</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(50)">50</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(100)">100</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(150)">150</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(200)">200</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(500)">500</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(1000)">1000</b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="col" align="center">
        <b-pagination
          size="sm"
          :total-rows="totalRowsC"
          v-model="currentPage"
          :per-page="rowsPerPageC"
          hide-ellipsis
          :limit="paginationButtonsLimit"
          align="center"
          @change="pageChanged"
        >
        </b-pagination>
      </div>
      <div class="col" align="right">
        <span>Total Rows {{totalRowsC}}</span>
      </div>
    </div>

    <br/>
    <button type="button" class="btn btn-primary" @click="refreshTable()" :disabled="showLoadingAnimation">Refresh
    </button>
    <b-table small bordered hover :items="tableRows" :fields="tableHeaders" @row-clicked="tableRowClicked">
      <template slot="status" slot-scope="row">
        <span>{{row.item.status}}</span>
        <button v-if="row.item.status == 'WAITING'" type="button" class="btn btn-primary"
                @click="approveOrRejectRequest()">Decide
        </button>
      </template>
    </b-table>

    <img src="static/img/Rolling.svg" alt="Loading data..."
         style="margin-left:auto; margin-right:auto; display: block;"
         v-if="showLoadingAnimation">
    <p style="text-align: center"
       v-if="showLoadingError">
      Loading error:
    </p>
    <p style="text-align: center"
       v-if="showNoResult">
      No Result
    </p>

    <!-- Modal Component -->
    <b-modal id="modal1" title="Decide" v-model="approveRejectModalShow">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col><label v-if="selectedRowItem">Choose to Approve or Reject the pairing request of
          {{selectedRowItem.invoiceNumberOne}} and {{selectedRowItem.invoiceNumberTwo}} by
          {{selectedRowItem.requester}}</label></b-col>
      </b-row>
      <b-tabs>
        <b-tab title="APPROVE" active>
          <b-row class="mb-1">
            <b-col><label><b>NOTE: Once approved, request cannot be rejected</b></label></b-col>
          </b-row>
          <b-row>
            <b-col>
              <button type="button" class="btn btn-success" @click="approveRequest()">Approve</button>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="REJECT">
          <b-row class="mb-1">
            <b-col><label><b>NOTE: Once rejected, request cannot be approved</b></label></b-col>
          </b-row>
          <b-row>
            <b-col><label for="rejectReason">Reject Reason:</label></b-col>
            <b-col><input type="text" id="rejectReason" placeholder="" v-model="rejectReason"></b-col>
          </b-row>
          <b-row>
            <b-col>
              <button type="button" class="btn btn-danger" @click="rejectRequest()">Reject</button>
            </b-col>
          </b-row>
          </b-row>
        </b-tab>
      </b-tabs>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary"
               @click="approveRejectModalShow = !approveRejectModalShow">
          Close
        </b-btn>
      </div>
    </b-modal>

    <MyModal v-if="showUpdatingModal" v-on:close="closeUpdatingModal()" headerTitle="Updating..."
             bodyMessage="Please wait"/>

    <MyModal v-if="showUpdateSuccessModal" v-on:close="closeUpdateSuccessModal()" headerTitle="Success"
             bodyMessage="Update Success."/>
    <MyModal v-if="showUpdateFailedModal" v-on:close="closeUpdateFailModal()" headerTitle="Failed"
             :bodyMessage="updateFailMessage"/>

  </div>
</template>

<script>
import {MyModal} from '../components/'

export default {
  components: {
    MyModal
  },
  data () {
    return {
      currentPage: this.$store.state.usrstomod.currentPage,
      paginationButtonsLimit: 3,
      selectedRowItem: null,
      searchModalShow: false,
      rejectReason: '',
      filterObject: {
        campaignId: '',
        requester: '',
        invoiceNumberOne: '',
        invoiceNumberTwo: '',
        status: ''
      }
    }
  },
  created: function () {
    this.$store.dispatch('pairmod/showAllPairRequests', {orderBys: 'createdDate'})
  },
  updated: function () {
    // console.log('VUEJS updated hook!')
    let tableElement = document.getElementsByTagName('table')[0]
    let tableOriginalWidth = tableElement.offsetWidth
    // console.log('table width: ' + tableOriginalWidth)

    let tableHeaders = document.getElementsByTagName('th')
    // console.log('tableHeaders: ' + tableHeaders.length)
    let tableBodyCells = document.getElementsByTagName('td')
    // console.log('tableBodyCells: ' + tableBodyCells.length)
    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      let totalColumnWidth = 0
      tableElement.style.width = (tableOriginalWidth * 2) + 'px'
      tableElement.style.maxWidth = (tableOriginalWidth * 2) + 'px'
      // console.log('Post Process: Updated table width to: ' + tableElement.offsetWidth)
      // let totalDiffs = 0
      for (let i = 0; i < tableHeaders.length; i++) {
        let headerWidth = tableHeaders[i].offsetWidth
        let cellWidth = tableBodyCells[i].offsetWidth
        // console.log(i + '-Header width: ' + headerWidth)
        // console.log(i + '-Cell width: ' + cellWidth)
        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px'
          // console.log('updated header width to: ' + tableHeaders[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px'
          // console.log('update cell width to: ' + tableBodyCells[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px'
        tableElement.style.maxWidth = totalColumnWidth + 'px'
        // console.log('Updated table width to: ' + tableElement.offsetWidth)
      }
    }
  },
  methods: {
    pageChanged: function (pageNumber) {
      this.currentPage = pageNumber
      console.log('User changed page to number: ' + this.currentPage)
      this.$store.commit('pairmod/changePageNumber', this.currentPage)
      this.$store.dispatch('pairmod/showAllPairRequests', {orderBys: 'createdDate'})
    },
    rowsPerPageSelected: function (rows) {
      console.log('rowsPerPageSelected, rows: ' + rows)
      let intRows = parseInt(rows)
      if (this.$store.state.claimmod.rowsPerPage !== intRows) {
        this.currentPage = 1
        this.$store.commit('pairmod/changePageNumber', this.currentPage)
        this.$store.commit('pairmod/setRowsPerPage', intRows)
        this.$store.dispatch('pairmod/showAllPairRequests', {orderBys: 'createdDate'})
      }
    },
    tableRowClicked: function (item, index, event) {
      console.log('Table row clicked')
      console.log('item: ' + item)
      this.$store.commit('pairmod/selectTableRow', item.pairRequestsDocId)
      this.selectedRowItem = item
    },
    refreshTable: function () {
      this.$store.dispatch('pairmod/showAllPairRequests', {orderBys: 'createdDate'})
    },
    filterTable: function () {
      this.searchModalShow = false
      this.$store.dispatch('pairmod/filterTable', this.filterObject)
    },
    clearFilters: function () {
      let haveFilter = false
      for (let i in this.filterObject) {
        if (!this.filterObject[i] || this.filterObject[i] === '') {
          haveFilter = true
        }
        this.filterObject[i] = ''
      }
      if (!haveFilter) {
        return
      }
      this.$store.dispatch('pairmod/showAllPairRequests', {orderBys: 'createdDate'})
    },
    approveOrRejectRequest: function () {
      if (this.selectedRowItem) {
        this.$store.commit('pairmod/toggleshowApproveOrRejectModal', true)
      }
    },
    approveRequest: function () {
      this.$store.dispatch('pairmod/approveRequest',
        {
          pairId: this.selectedRowItem.pairRequestsDocId,
          campaignId: this.selectedRowItem.campaignId,
          requester: this.selectedRowItem.requester,
          invoiceNumberOne: this.selectedRowItem.invoiceNumberOne,
          invoiceNumberTwo: this.selectedRowItem.invoiceNumberTwo,
          status: this.selectedRowItem.status,
          rejectReason: this.selectedRowItem.rejectReason
        }
      )
    },
    rejectRequest: function () {
      this.$store.dispatch('pairmod/rejectRequest', {
        pairId: this.selectedRowItem.pairRequestsDocId,
        rejectReason: this.rejectReason
      })
    },
    closeUpdatingModal: function () {
      this.$store.commit('pairmod/toogleShowUpdatingModal', false)
    },
    closeUpdateSuccessModal: function () {
      this.$store.commit('pairmod/toggleShowUpdateSuccessModal', false)
    },
    closeUpdateFailModal: function () {
      this.$store.commit('pairmod/toogleShowUpdateFailedModal', false)
    }
  },
  computed: {
    tableRows: function () {
      return this.$store.state.pairmod.all
    },
    tableHeaders: function () {
      return this.$store.getters['pairmod/getHeaders']
    },
    totalRowsC: function () {
      return this.$store.state.pairmod.totalRows
    },
    rowsPerPageC: {
      get: function () {
        return this.$store.state.pairmod.rowsPerPage
      },
      set: function (newValue) {
        this.$store.commit('pairmod/setRowsPerPage', newValue)
      }
    },
    rowsPerPageCText: function () {
      return '' + this.$store.state.pairmod.rowsPerPage
    },
    approveRejectModalShow: {
      get: function () {
        return this.$store.state.pairmod.showApproveOrRejectModal
      },
      set: function (newValue) {
        this.$store.commit('pairmod/toggleshowApproveOrRejectModal', newValue)
      }
    },
    showUpdatingModal: {
      get: function () {
        return this.$store.state.pairmod.showUpdatingModal
      },
      set: function (newValue) {
        this.$store.commit('pairmod/toggleShowUpdatingModal', newValue)
      }
    },
    showUpdateSuccessModal: {
      get: function () {
        return this.$store.state.pairmod.showUpdateSuccessModal
      },
      set: function (newValue) {
        this.$store.commit('pairmod/toggleShowUpdateSuccessModal', newValue)
      }
    },
    showUpdateFailedModal: {
      get: function () {
        return this.$store.state.pairmod.showUpdateFailedModal
      },
      set: function (newValue) {
        this.$store.commit('pairmod/toggleShowUpdateFailedModal', newValue)
      }
    },
    updateFailMessage: function () {
      return this.$store.state.pairmod.updateFailMessage
    },
    showLoadingAnimation: function () {
      return this.$store.state.usrstomod.showLoadingAnimation
    },
    showLoadingError: function () {
      return this.$store.state.usrstomod.showLoadingError
    },
    showNoResult: function () {
      return this.$store.state.usrstomod.showNoResult
    }
  },
  name: 'PairRequests'
}
</script>



// WEBPACK FOOTER //
// src/views/PairRequests.vue